import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const stats = [
  { label: 'Peak Earth population (2058)', value: '7.4 Billion' },
  { label: 'Earth population by 2501', value: '3 Billion' },
  { label: 'Lives lost to collapse & pandemic', value: '4.4 Billion' },
  { label: 'Marburg-X casualties (2067–2070)', value: '340 Million' },
];

const WorldCost = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="The Cost That Was Never Hidden" subtitle="The Accounting" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            The same chronicle that describes Venus terraformed and Titan colonized does not flinch from the accounting. Between Earth's peak population of <span className="text-white font-semibold">7.4 billion in 2058</span> and its 2501 population of <span className="text-white font-semibold">3 billion</span>, 4.4 billion lives were lost — to climate collapse, to the Marburg-X pandemic, to the Great Erosion.
          </p>
          <p className="text-gray-400 leading-relaxed">
            The book names them: teachers in Kinshasa, farmers walking to flooded Mumbai, water engineers dying of dehydration while saving others. They are not statistics. They are the price of a civilization that knew and chose not to act in time.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="bg-brand-surface border border-white/5 rounded-2xl p-8"
        >
          <div className="space-y-6">
            {stats.map((stat, i) => (
              <div key={i} className="flex justify-between items-center border-b border-white/5 pb-5 last:border-0 last:pb-0">
                <span className="text-gray-500 text-sm pr-4">{stat.label}</span>
                <span className="text-brand-accent font-display font-bold text-xl flex-shrink-0">{stat.value}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default WorldCost;